// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

export interface xCheckoutInnerContainerStyles {
    container?: InjectableCss;
    section?: InjectableCss;
    sectionTwoColums?: InjectableCss;
    hr?: InjectableCss;
    title?: TypographyProps;
    sectionTitle?: TypographyProps;
    label?: TypographyProps;
    value?: TypographyProps;
}

export const xCheckoutInnerContainerStyles: xCheckoutInnerContainerStyles = {
    container: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            column-gap: 135px;
            row-gap: 24px;
            ${xScreen("lte", "md")} {
                flex-direction: column;
            }

            @media print {
                display: block;
                clear: both;
                flex-direction: column;
                width: 100%;
            }
        `,
    },
    section: {
        css: css`
            width: 430px;

            ${xScreen("lte", "md")} {
                width: 100%;
            }

            @media print {
                &&&{
                    display: inline-block;
                    vertical-align: top;
                    flex-direction: column;
                    width: 430px;
                    margin-bottom: 24px;
                    &:first-of-type {
                        margin-right: 16px;
                    }
                }
            }

            ${({ fullWidth }: any) =>
                fullWidth &&
                `
                    width: 100%;
                    
                    @media print {
                        width: 100%;
                    }
            `}
        `,
    },
    sectionTwoColums: {
        css: css`
            display: flex;
            column-gap: 22px;
            align-items: baseline;
            > div {
                width: 100%;
            }
        `,
    },
    hr: {
        css: css`
            border-top: 1px solid ${color("common.border")};
            clear: both;
            width: 100%;
            ${({ addMargin }: any) => addMargin && ` margin: 24px 0 ;`}
        `,
    },
    title: {
        variant: "h3",
        css: css`
            margin-bottom: 0;
            letter-spacing: 0;
            line-height: 26px;
        `,
    },
    sectionTitle: {
        variant: "h6",
        css: css`
            margin-bottom: 12px;
        `,
    },
    value: {
        forwardAs: "span",
        size: 14,
        lineHeight: "22px",
        css: css`
            display: block;
            word-wrap: break-word;
            white-space: wrap;
            & + ${TypographyStyle} {
                margin-top: 8px;
            }
        `,
    },
    label: {
        forwardAs: "span",
        size: 12,
        lineHeight: "13px",
        weight: fontConfig.weight.bold,
        css: css`
            margin-right: 4px;
        `,
    },
};
